import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ProductInfo } from "abweb/dto/product/ProductInfo";
import { UserInfo } from "abweb/dto/user/UserInfo";
import { Callback1Arg } from "abweb/utils/callback/Callback1Arg";
import { ProductSpecificLocaleStrings } from "abweb/utils/locale/ProductSpecificLocaleStrings";

/**
 * SessionData is meant to store truly global application data.
 */
export class SessionData extends Callback1Arg {
  constructor() {
    super();
    // DO NOT SET THESE DIRECTLY! Set them through the set() method
    _defineProperty(this, "currentUser", void 0);
    _defineProperty(this, "productInfo", void 0);
    _defineProperty(this, "productSpecificLocaleStrings", void 0);
    this.currentUser = UserInfo.createAnonymousUser();
    this.productInfo = ProductInfo.createEmptyProductInfo();
    this.productSpecificLocaleStrings = new ProductSpecificLocaleStrings("", "");
  }

  /**
   * Reset all properties to initial values.
   */
  reset() {
    this.set("currentUser", UserInfo.createAnonymousUser());
    this.set("productInfo", ProductInfo.createEmptyProductInfo());
  }

  /**
   * Set a field to a value, and tell all listeners
   * @param field
   * @param value
   */
  set(field, value) {
    // Value of null leaves existing value in place
    if (value == null) return;
    switch (field) {
      case "currentUser":
        this.currentUser = value;
        break;
      case "clientProductInfo":
        // add client info to the existing product info
        this.productInfo.setClientProductInfo(value);
        break;
      case "productInfo":
        // if existing product info has client product info, it stays around
        const currentClientInfo = this.productInfo.getClientProductInfo();
        this.productInfo = value;
        this.productInfo.setClientProductInfo(currentClientInfo);
        break;
      case "productSpecificLocaleStrings":
        this.productSpecificLocaleStrings = value;
        break;
    }
    this.callAll({
      field,
      value
    });
  }
}
//# sourceMappingURL=SessionData.js.map
